import { render, staticRenderFns } from "./TyphoonRedEmergencyPlan.vue?vue&type=template&id=31d4c04e&scoped=true"
import script from "./TyphoonRedEmergencyPlan.vue?vue&type=script&lang=js"
export * from "./TyphoonRedEmergencyPlan.vue?vue&type=script&lang=js"
import style0 from "./TyphoonRedEmergencyPlan.vue?vue&type=style&index=0&id=31d4c04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4c04e",
  null
  
)

export default component.exports